import AST from './AST';
import ASTCompiler from './ASTCompiler';
import Lexer from './Lexer';
import { AND, NOT, OR } from './constants';

export default class SearchExp {
  constructor(expr) {
    this.lexer = new Lexer();
    this.ast = new AST(this.lexer);
    this.ASTCompiler = new ASTCompiler(this.ast);
    this._matcher = this.ASTCompiler.compile(expr);
  }

  match(text) {
    return this._matcher(text, function (text, query, position) {
      const index = text.indexOf(query);
      let newPosition = position;
      const contains = index !== -1;
      if (contains) {
        newPosition = index + query.length;
      }
      return [contains, newPosition];
    });
  }
}

export const isSearchExp = (query) =>
  [AND, NOT, OR].some((o) => query.includes(o));
